import PastJobLocations from './PastLocations';

export default PastJobLocations;
